import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  quote: string;
  product?: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  quote,
  product
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-brand-black border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col h-full hover:border-brand-green/30 transition-colors" data-id="element-303">
      <div className="flex items-center gap-4 mb-6" data-id="element-304">
        <div className="w-12 h-12 rounded-full bg-brand-dark border border-brand-green/30 flex items-center justify-center text-brand-light font-bold text-lg" data-id="element-305">
          {initials}
        </div>
        <div data-id="element-306">
          <div className="font-bold text-white" data-id="element-307">{name}</div>
          <div className="text-sm text-gray-400" data-id="element-308">{location}</div>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-309">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-310" />)}
      </div>

      <p className="text-gray-300 italic flex-grow" data-id="element-311">"{quote}"</p>

      {product && <div className="mt-6 pt-4 border-t border-gray-800 text-xs text-brand-light font-medium" data-id="element-312">
          Compró: {product}
        </div>}
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Buenos Aires',
    quote: 'En 3 semanas dejé de olvidarme los nombres en plena conversación. Mi marido me preguntó qué me habían dado.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Córdoba',
    quote: 'La niebla de las 3 PM desapareció. Por fin termino el día con la misma energía con la que lo empiezo.'
  }, {
    initials: 'RM',
    name: 'Rosa M.',
    location: 'Mendoza',
    quote: 'Tenía miedo de que fuera el Alzheimer empezando. Era el intestino. Este sistema me lo explicó y me lo resolvió.'
  }];
  return <section className="py-20 bg-brand-dark" data-id="element-313">
      <div className="container mx-auto px-4" data-id="element-314">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-315">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-316" />)}
        </div>
      </div>
    </section>;
}